import { API_BASE_URL } from '../config/api'
import { getAuthHeaders } from '../utils/authUtils'

export interface VolunteerIdVerification {
  id: string
  status: 'PENDING' | 'APPROVED' | 'REJECTED'
  submittedAt: string
  reviewedAt?: string | null
  rejectionReason?: string | null
}

export async function getMyVolunteerIdVerification(): Promise<VolunteerIdVerification | null> {
  const response = await fetch(`${API_BASE_URL}/api/volunteer-verification/me`, {
    headers: {
      ...getAuthHeaders()
    }
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Failed to fetch volunteer ID verification')
  return data.data || null
}

export async function submitVolunteerIdPhoto(photo: File): Promise<VolunteerIdVerification> {
  const form = new FormData()
  form.append('photo', photo)

  const headers = getAuthHeaders()
  const response = await fetch(`${API_BASE_URL}/api/volunteer-verification/id`, {
    method: 'POST',
    headers: {
      // DO NOT set Content-Type for multipart; browser will set boundary
      ...headers
    },
    body: form
  })

  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Failed to submit ID photo')
  return data.data
}


